<template>
    <b-col sm="12" md="6">
        <label>Dostawca</label>
        <validation-provider rules="required" v-slot="{ errors }">
            <v-select label="nameWithActiveCertificate" :options="producer" v-on:input="verifyCertificate"
                v-model="selectedProducer" class="producer"></v-select>
            <div class="alert alert-danger mt-2" role="alert" v-show="!isCertificateValid || isCertificateNearEnd">
                <span v-show="isCertificateNearEnd">Certyfikat niedługo straci ważność!</span>
                <span v-show="!isCertificateValid">Certyfikat stracił ważność!</span>
            </div>
            <b-alert v-show="errors[0] !== undefined" show variant="danger">{{ errors[0] }}</b-alert>
        </validation-provider>
    </b-col>
</template>

<script>
export default {
    name: "ProducerPicker",
    computed: {
        producer() {
            return this.$store.state.deliveryFormData.producers;
        },
    },
    data() {
        return {
            isCertificateValid: true,
            isCertificateNearEnd: false,
            selectedProducer: {},
        }
    },
    methods: {
        verifyCertificate: function (event) {
            if (event) {
                this.verifyIsCertificateIsValid(event);
                this.verifyIsCertificateNearEnd(event);
            }
        },
        verifyIsCertificateNearEnd: function (selectedProducer) {
            this.isCertificateNearEnd = false;
            var today = this.$moment().add(14, "d");
            var activeCertificate = selectedProducer.certificates.filter(
                (item) =>
                    this.$moment(item.validFrom) <= today &&
                    this.$moment(item.validTo) >= today
            );
            if (activeCertificate.length > 0) {
                if (this.$moment(activeCertificate[0].validTo) >= today) {
                    this.isCertificateNearEnd = false;
                } else {
                    this.isCertificateNearEnd = true;
                }
            } else {
                this.isCertificateNearEnd = false;
            }
        },
        verifyIsCertificateIsValid: function (selectedProducer) {
            this.isCertificateValid = true;
            var today = this.$moment();
            var activeCertificate = selectedProducer.certificates.filter(
                (item) =>
                    this.$moment(item.validFrom) <= today &&
                    this.$moment(item.validTo) >= today
            );
            if (activeCertificate.length > 0) {
                if (this.$moment(activeCertificate[0].validTo) >= today) {
                    this.isCertificateValid = true;
                    return;
                }
            }
            this.isCertificateValid = false;
        }
    },
}
</script>